export const MODAL_SOCIO_OPEN = "deca.socio.MODAL_SOCIO_OPEN";
export const MODAL_SOCIO_CLOSE = "deca.socio.MODAL_SOCIO_CLOSE";
export const ADD_SAGA_SOCIO_LISTGRID = "deca.socio.ADD_SAGA_SOCIO_LISTGRID";
export const ADD_STATE_SOCIO_LISTGRID = "deca.socio.ADD_STATE_SOCIO_LISTGRID";
export const DELETE_STATE_SOCIO_LISTGRID =
  "deca.socio.DELETE_STATE_SOCIO_LISTGRID";
export const SET_STATE_SOCIO = "deca.socio.SET_STATE_SOCIO";
export const SET_SAGA_SOCIO = "deca.socio.SET_SAGA_SOCIO";
export const SET_SAGA_PRINCIPAL_SOCIO = "deca.socio.SET_SAGA_PRINCIPAL_SOCIO";
export const DELETE_SAGA_SOCIO_GRID = "deca.socio.DELETE_SAGA_SOCIO_GRID";
export const SET_STATE_LIST_GRID_SOCIO = "deca.socio.SET_STATE_LIST_GRID_SOCIO";
export const SET_PREFIX_SOCIO = "deca.socio.SET_PREFIX_SOCIO";
export const GET_SOLICITANTE = "deca.socio.GET_SOLICITANTE";
export const SET_NEW_OPEN = "mobiliario.decasolicitacao.socio.SET_NEW_OPEN";
export const SET_STATE_ENDERECO_SOCIO =
  "mobiliario.decasolicitacao.socio.SET_STATE_ENDERECO_SOCIO";
export const RESET_STATE_SOCIO =
  "mobiliario.decasolicitacao.socio.RESET_STATE_SOCIO";
